import { createClient, defaultPlugins } from "villus";
import acceptLanguagePlugin from "./acceptLanguagePlugin";
import authPlugin from "./authPlugin";

export const villusClient = createClient({
  url: `https://${window.Shopify.shop}/api/${window.themeVariables.environment.variables.shopify_api_version}/graphql.json`,
  use: [authPlugin, acceptLanguagePlugin, ...defaultPlugins()],
  cachePolicy: [import.meta.env.DEV ? "network-only" : "cache-first"],
});
